import { DE } from './content.de'
import { EN } from './content.en'
import type { Language, TutorialContent } from './types'

export const TUTORIAL: Record<Language, TutorialContent> = { de: DE, en: EN }
